import http from "../../http-common";

const login = (data) => {
  return http.post("/User/Login", data);
};

//const updateTermsUse = (data) => {
//  return http.put("/User/UpdateTermsUser", data);
//};

const getSystemParameterList = (data) => {
  return http.get("/SystemParameter/GetSystemParameterListForLogin", data);
};

export default { login, /*updateTermsUse,*/ getSystemParameterList };
